const __WEBPACK_NAMESPACE_OBJECT__ = require("@noble/hashes/scrypt");